<template>
    <div v-if="part.queue.length > 0">
        <div class="p-2">
            <div class="text-center p-2 pb-4">
                <span class="h5 font-weight-light"><i class="fa fa-ellipsis-v"></i> {{part.title}}</span>
            </div>

            <div class="d-flex flex-column">
                <div v-for="schedule in part.queue" class="border rounded mt-2 mb-2 p-2">
                    <template>
                        <div class="row">
                            <div class="col-md-10">
                                <div>
                                    <div class="h6 font-weight-bold">{{getDateTime(schedule.start, schedule.end)}}</div>
                                    <div class="text-muted">{{schedule.location.name}} {{schedule.location.city ? schedule.location.city.name : ''}}</div>
                                    <div class="text-muted">{{getTreatmentString(schedule)}}</div>
                                    <div class="text-muted"><img class="round-profile-picture" :src="'/therapist_profile_picture/'+schedule.therapist.profile_picture_path"> {{schedule.therapist.user.name}}</div>
                                </div>
                            </div>

                            <div class="col-md-2 d-flex flex-column justify-content-around" >

                                <div class="text-center" v-if="schedule.is_booked"><i class="fa fa-warning"></i> Fortfarande bokad</div>
                                <div v-else>
                                    <a :href="portalLink(schedule)" class="btn btn-sm btn-outline-primary w-100">
                                        <i class="fa fa-plus"></i> Gå till portal</a>
                                </div>

                                <form action="/queue" method="POST">
                                    <input type="hidden" name="_token" :value="csrf()">
                                    <input type="hidden" name="_method" value="DELETE">
                                    <input type="hidden" name="schedule_id" :value="schedule.id">
                                    <input type="hidden" name="is_ajax" value="0">
                                    <button class="btn btn-sm btn-outline-danger w-100">
                                        <i class="fa fa-times-circle-o"></i> Avbryt kö</button>
                                </form>

                            </div>

                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
    export default {
        props: ['part'],
        name: "CustomerDashQueue",
        methods: {
            portalLink(schedule) {
                let link = "/portal?date=" + this.getDateOnlyString(schedule.start)+"&location="+schedule.location.id;

                return link;
            },
            csrf() {
                return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            },
            removeFromQueue(){
                axios.delete('/queue', {
                    params: {
                        'schedule_id': this.schedule.id
                    }
                }).then((res) => {
                    if(res.data[0]) {
                        Vue.toasted.success( res.data[1])
                        this.$emit('close');
                    } else {
                        Vue.toasted.error( res.data[1])
                    }
                });
            },
            getDateTime(dateString, dateStringEnd) {
                return moment(dateString).format('YYYY-MM-DD') + ' kl. ' + moment(dateString).format('HH:mm') + ' - ' + moment(dateStringEnd).format('HH:mm');
            },
            getDate: function (dateString) {
                let tempDate = new Date(dateString);

                return tempDate.getYMD();
            },
            getDateOnlyString: function (dateString) {
                let tempDate = new Date(dateString);

                return tempDate.getYMD();
            },
            getHrsMins: function (dateString) {
                let tempDate = new Date(dateString);
                let hrsMins = tempDate.getHrsMins();

                return hrsMins;
            },
            getStartToEndHrsMins: function (startDateString, endDateString) {
                let startHrsMins = this.getHrsMins(startDateString);
                let endHrsMins = this.getHrsMins(endDateString);

                return startHrsMins + " - " + endHrsMins;
            },
            getTreatmentString(schedule){
                if(schedule.treatments.length > 1){
                    return schedule.treatments.length + " behandlingar";
                }

                return schedule.treatments[0].name;
            },
        }
    }
</script>

<style scoped>

</style>
